"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.refineDesign = refineDesign;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const aiSummarization_1 = require("./utils/aiSummarization");
const weavePlan_1 = require("./weavePlan");
const SYSTEM_PROMPT = `You are an AI assistant embedded in REslava Loom, a document-driven workflow system.
Your task: read this design document and produce an improved version — sharpen the goal, clarify architecture, fill weak sections, surface decisions and open questions.
If the Additional Context contains a locked requirements (req) doc — sections ✅ Included / ❌ Excluded / ⛓ Constraints, each item prefixed with an inline-code \`IN\`/\`EX\`/\`C\` id — treat every ❌ Excluded item and ⛓ Constraint as a HARD BOUNDARY: do not (re)introduce excluded scope, and keep the design within the stated constraints.
Respond with exactly this format — nothing else before or after:

TITLE: <improved or unchanged title>

## Goal
<what this design achieves in 1-2 sentences>

## Context
<background, constraints, motivation>

## Design
<the proposed solution — architecture, components, key decisions, trade-offs>

## Decisions
<concrete decisions made, one per bullet>

## Open questions
<anything still unresolved>`;
async function refineDesign(input, deps) {
    const doc = await deps.loadDoc(input.filePath);
    const content = input.extraContext
        ? `## Additional Context\n\n${input.extraContext}\n\n---\n\n${doc.content}`
        : doc.content;
    const messages = (0, aiSummarization_1.buildSummarizationMessages)(SYSTEM_PROMPT, `design document titled "${doc.title}"`, content);
    const reply = await deps.aiClient.complete(messages);
    const { title, body } = (0, aiSummarization_1.parseTitleAndBody)(reply);
    // Re-baseline the staleness marker: a refine brings the design up to the current
    // idea, so re-stamp idea_version to the live idea version (else it stays "stale").
    const threadDir = path.dirname(input.filePath);
    const threadId = path.basename(threadDir);
    const idea = await (0, weavePlan_1.parentIdeaVersion)(threadDir, threadId, { loadDoc: deps.loadDoc, fs: deps.fs });
    const refined = (0, dist_1.designReducer)(doc, { type: 'REFINE_DESIGN' });
    const updated = {
        ...refined,
        title,
        content: `# ${title}\n\n${body}`,
        ...(idea ? { idea_version: idea.version } : {}),
    };
    await deps.saveDoc(updated, input.filePath);
    return { filePath: input.filePath, version: updated.version };
}
